(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .controller("PauseLearnerEmailsModalCtrl", ["pauseLearnerEmailService", "messageService", "calendarSettingsService", "$scope", pauseLearnerEmailsModalCtrl]);
    function pauseLearnerEmailsModalCtrl(pauseLearnerEmailService, messageService, calendarSettingsService, $scope) {
        var vm = this;
        vm.loading = true;
        //Date picker config
        vm.format = "yyyy-MM-dd";
        calendarSettingsService.calendarSetup($scope);
        vm.open = calendarSettingsService.open;
        pauseLearnerEmailService.getData().then(function (data) {
            vm.model = angular.copy(data);
            if (vm.model.date) {
                if (!(vm.model.date instanceof Date))
                    vm.model.date = new Date(vm.model.date + "Z");
            }
            vm.loading = false;
            vm.showResume = vm.model.learnerEmailsPausedState <= 2;
        });
        vm.save = function () {
            if (vm.form.$valid) {
                pauseLearnerEmailService.save(vm.model, function () {
                    messageService.success("common.changesSaved");
                    $scope.$close();
                }, function (error) {
                    messageService.error(error);
                });
            }
            else {
                vm.showErrors = true;
            }
        };
    }
}());
